import _SegmentationUtil from './../_SegmentationUtil';

export default [() => {
    return {
        restrict: 'EA',
        controller: ['$element', '$q', 'CampaignDataService', function ($element, $q, CampaignDataService) {
            return _SegmentationUtil($element, $q.resolve(CampaignDataService));
        }]
    };
}];